import React, { useEffect, useState } from "react";
import "./management-overview.scss";
import { useDispatch, useSelector } from "react-redux";
import { userActions } from "../../_actions";
import ManageIcon from "./img/manageIcon.png";
import BackIcon from "./img/back.png";
import { userConstants } from "../../_constants";
import InfoCard from "./component/info-card";
import LoadMoreComponent from "../../_components/show-more";
import { SectionOne, SectionThree, SectionTwo } from "./component";
import Select from "react-select";
import { SectionFour } from "./component/section-four";
import snjobLogo from "./img/snjob-logo.png";
import { useHistory } from "react-router-dom";

const YEARS = ["1397", "1398", "1399", "1400", "1401", "1402", "1403"];
const yearOptions = YEARS.map((year) => ({
  name: year,
  value: year,
}));

export function ManagementOverview() {
  const { me, year } = useSelector((state) => state.globalStorage);
  const dispatch = useDispatch();
  const history = useHistory();
  const [hospitalInfo, setHospitalInfo] = useState(null);
  const [properties, setProperties] = useState(null);
  const [strategies, setStrategies] = useState(null);
  const [programs, setPrograms] = useState(null);
  const [hospitalWardList, setHospitalWardList] = useState(null);
  const [hospitalGraph, setHospitalGraph] = useState(null);
  const [strategicGoals, setStrategicGoals] = useState(null);
  const [committees, setCommittees] = useState(null);
  const [goalGroup, setGoalGroup] = useState(null);
  const [patientSafetyData, setPatientSafetyData] = useState(null);
  const [hospitalErrors, setHospitalErrors] = useState(null);
  const [selectedYear, setSelectedYear] = useState(yearOptions[6]);

  const [sectionVisibility, setSectionVisibility] = useState({
    section_1: false,
    section_2: false,
    section_3: false,
    section_4: false,
  });

  const visibleChangeHandler = (sectionNumber) => {
    setSectionVisibility({
      ...sectionVisibility,
      [`section_${sectionNumber}`]: true,
    });
  };

  useEffect(() => {
    dispatch(userActions.getHospitals());
    if (year) {
      const getYear = yearOptions.find((y) => y.value === year);
      setSelectedYear(getYear);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [year]);

  useEffect(() => {
    if (me && me.hospital_id) {
      dispatch(
        userActions.API("get", `/v1/hospital/${me.hospital_id}/detail`)
      ).then((res) => {
        setHospitalInfo(res?.data?.hospital);
      });

      dispatch(
        userActions.API(
          "get",
          `/v1/user/hospital/profile/propertises?year=${selectedYear.value}`
        )
      ).then((res) => {
        setProperties(res?.data);
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [me, selectedYear]);

  // section 1 requests
  useEffect(() => {
    if (sectionVisibility.section_1) {
      dispatch(
        userActions.API(
          "get",
          "v1/user/hospital/ward_lists?section_grouped=true"
        )
      ).then((res) => {
        setHospitalWardList(res.data);
      });

      dispatch(
        userActions.API(
          "get",
          `v1/user/hospital/strategy/goals?year=${selectedYear.value}`
        )
      ).then((res) => {
        setStrategicGoals(res.data);
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sectionVisibility.section_1, selectedYear]);

  // section 2 requests
  useEffect(() => {
    if (sectionVisibility.section_2) {
      dispatch(
        userActions.API(
          "get",
          `/v1/user/hospital/strategies?year=${selectedYear.value}`
        )
      ).then((res) => {
        setStrategies(res.data?.[0]);
      });

      dispatch(
        userActions.API(
          "get",
          `/v1/user/hospital/program/dashboard?year=${selectedYear.value}&program_type=برنامه`
        )
      ).then((res) => {
        setPrograms(res.data);
      });

      dispatch(
        userActions.API(
          "get",
          `v1/user/hospital/organisation_charts?year=${selectedYear.value}`
        )
      ).then((res) => {
        setHospitalGraph(res.data?.[0]?.file?.url);
      });

      dispatch(
        userActions.API(
          "get",
          `v1/user/hospital/programs/goal_grouped??year=${selectedYear.value}`
        )
      ).then((res) => {
        setGoalGroup(res.data);
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sectionVisibility.section_2, selectedYear]);

  // section 3 requests
  useEffect(() => {
    if (sectionVisibility.section_3) {
      dispatch(
        userActions.API(
          "get",
          `v1/user/hospital/event_statistics?year=${selectedYear.value}`
        )
      ).then((res) => {
        setCommittees(res.data);
      });

      dispatch(
        userActions.API(
          "get",
          `v1/user/hospital/psvc/statistics?year=${selectedYear.value}`
        )
      ).then((res) => {
        setPatientSafetyData(res.data);
      });

      dispatch(
        userActions.API(
          "get",
          `v1/user/hospital/error_control/statistics?year=${selectedYear.value}`
        )
      ).then((res) => {
        setHospitalErrors(res.data);
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sectionVisibility.section_3, selectedYear]);

  const onChangeYear = (yearOb) => {
    setSectionVisibility({
      section_1: false,
      section_2: false,
      section_3: false,
      section_4: false,
    });
    setSelectedYear(yearOb);
  };

  return (
    <div className="management_overview">
      <div className="top_header">
        <div className="right_side">
          <img src={ManageIcon} alt="" className="logo" />
          <p className="title iran-sans_Bold">گـزارش رهبـری و مدیـریت</p>
        </div>
        <img
          src={BackIcon}
          alt=""
          onClick={history.goBack}
          className="back_logo pointer"
        />
      </div>
      <div className="header">
        <div className="container-fluid px-5">
          <div className="year_select">
            <Select
              className="text-center custom-select-2 "
              value={selectedYear}
              placeholder=""
              onChange={onChangeYear}
              options={yearOptions}
              getOptionLabel={(opt) => opt.name}
              getOptionValue={(opt) => opt.value}
              styles={{
                singleValue: (baseStyles) => ({
                  ...baseStyles,
                  marginRight: "25px",
                }),
              }}
            />
          </div>
        </div>
      </div>
      <div className="content_container">
        <div className="container-fluid px-5">
          <div className="user_info">
            <p className="info_title iran-sans_Bold">
              کاربـر گرامـی بـه داشبـورد رهبـری و مدیـریت سامـانـه نویـن جامع
              اطلاعات بیـمارستـان (سنجـاب) خوش آمدیـد
            </p>
          </div>
          <div className="hospital_info">
            <span className="title">
              قـابل توجــه تمـامــی اطلاعـات این صفحــه از{" "}
              <span className="iran-sans_Bold" style={{ color: "#104c82" }}>
                سامـانه سنجـاب
              </span>{" "}
              به صورت خودکـار و لحظــه ای گزارش گیــری شده است
            </span>
            <div className="hospital_card">
              <img
                src={`${userConstants.SERVER_URL}${hospitalInfo?.logo?.url}`}
                alt=""
                className="hospital_logo"
              />
              <p className="hospital_name iran-sans_Bold">
                {hospitalInfo?.name}
              </p>
            </div>
          </div>
          {hospitalInfo?.id === 65 ? (
            <InfoCard
              className="about_hospital"
              title={`معــرفــی ${hospitalInfo?.name}`}
            >
              <h1 className="title iran-sans_Bold">
                مامـوریت هـای محولـه مقـام معظـم رهبـری به تولیت معظـم آستـان
                قدس رضـوی
              </h1>
              <span>{hospitalInfo?.description.slice(0, -31)}</span>
              <p className="author iran-sans_Bold">
                {hospitalInfo?.description.slice(-31)}
              </p>
            </InfoCard>
          ) : (
            <InfoCard title={`معــرفــی ${hospitalInfo?.name}`}>
              <span>{hospitalInfo?.description.slice(0, -31)}</span>
            </InfoCard>
          )}
          <InfoCard className="all_information">
            <div className="all_information_container">
              <p className="information_title iran-sans_Bold">
                سایـر اطلاعـات {hospitalInfo?.name}
              </p>
              <div className="information_detail_container">
                <div className="detail_box">
                  <div className="text iran-sans_Bold">
                    تعـداد کل تخت هـای فعـال
                  </div>
                  <div className="caption">{properties?.[9]?.value || "0"}</div>
                </div>
                <div className="detail_box">
                  <div className="text iran-sans_Bold">
                    تعـداد کـل تخت هـای مصـوب
                  </div>
                  <div className="caption">{properties?.[8]?.value || "0"}</div>
                </div>
                <div className="detail_box">
                  <div className="text iran-sans_Bold">ضریب اشغـال تخت</div>
                  <div className="caption">
                    {properties?.[10]?.value || "0"}
                  </div>
                </div>
                <div className="detail_box">
                  <div className="text iran-sans_Bold">
                    وابستگـی سازمانـی بیمارستـان
                  </div>
                  <div className="caption no_number">
                    {properties?.[14]?.value || "-"}
                  </div>
                </div>
                <div className="detail_box">
                  <div className="text iran-sans_Bold">
                    آخریـن درجـه ارزیابـی بیمارستـان
                  </div>
                  <div className="caption no_number">
                    {properties?.[21]?.value || "-"}
                  </div>
                </div>
              </div>
            </div>
          </InfoCard>

          {/* section one */}
          <LoadMoreComponent
            handleChange={() => visibleChangeHandler(1)}
            isShow={sectionVisibility.section_1}
            label={"ادامـه مطـالب ..."}
          >
            <SectionOne
              hospitalInfo={hospitalInfo}
              wardList={hospitalWardList}
              strategicGoals={strategicGoals}
            />
          </LoadMoreComponent>

          {/* section two */}
          {sectionVisibility.section_1 && (
            <LoadMoreComponent
              handleChange={() => visibleChangeHandler(2)}
              isShow={sectionVisibility.section_2}
              label={"ادامـه مطـالب ..."}
            >
              <SectionTwo
                strategies={strategies}
                programs={programs}
                hospitalGraphUrl={hospitalGraph}
                goalGroup={goalGroup}
                year={selectedYear.value}
              />
            </LoadMoreComponent>
          )}

          {/* section three */}
          {sectionVisibility.section_1 && sectionVisibility.section_2 && (
            <LoadMoreComponent
              handleChange={() => visibleChangeHandler(3)}
              isShow={sectionVisibility.section_3}
              label={"ادامـه مطـالب ..."}
            >
              <SectionThree
                committees={committees}
                patientSafetyData={patientSafetyData}
                hospitalErrors={hospitalErrors}
              />
            </LoadMoreComponent>
          )}

          {/* section four */}
          {sectionVisibility.section_1 &&
            sectionVisibility.section_2 &&
            sectionVisibility.section_3 && (
              <LoadMoreComponent
                isShow={sectionVisibility.section_4}
                handleChange={() => visibleChangeHandler(4)}
                label={"ادامـه مطـالب ..."}
              >
                <SectionFour />
              </LoadMoreComponent>
            )}
          {sectionVisibility.section_4 && (
            <div className="footer">
              <img
                src={`${userConstants.SERVER_URL}${hospitalInfo?.logo?.url}`}
                alt=""
                className="hospital_logo"
              />
              <p className="footer_text">با تشکر {hospitalInfo?.name}</p>
              <img src={snjobLogo} alt="" className="snjob_logo" />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
